import { Component, ViewChild } from '@angular/core';
import { ModalContainerComponent } from '../../../../../components/modals/modal-container.component';
import { IModal } from '../../../../../components/modals/modal.interface';

@Component({
  templateUrl: './property-type-change-confirmation.component.html',
  standalone: false,
})
export class PropertyTypeChangeConfirmationComponent implements IModal {
  @ViewChild(ModalContainerComponent, { static: true })
  public container: ModalContainerComponent;
  public confirmed: boolean;

  public close(): void {
    this.container.closeModal();
  }

  public onConfirm(): void {
    this.confirmed = true;
    this.close();
  }
}
